/* eslint-disable */
import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import dataTable from "./components/base/dataTable.vue";
import pagination from "./components/base/pagination.vue";
import bounceLoader from "vue-spinner/src/BounceLoader.vue";
import i18n from "./i18n";
import deleteItem from "./components/base/deleteItem.vue";
import VueToast from "vue-toastification";
import "vue-toastification/dist/index.css";
import loader from "./components/loader.vue";
Vue.use(VueToast, {
  position:
    localStorage.getItem("YPlang") == "ar" ? "bottom-left" : "bottom-right",
});
Vue.use(VueToast);
Vue.component("dataTable", dataTable);
Vue.component("deleteItem", deleteItem);
Vue.component("pagination", pagination);
Vue.component("bounceLoader", bounceLoader);
Vue.component("loader", loader);

Vue.prototype.$formatDateAndTime = function (dateString) {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const date = new Date(dateString);
  const formattedDate = `${
    months[date.getMonth()]
  }-${date.getDate()}-${date.getFullYear()}`;
  const hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? " pm " : " am ";
  const formattedHours = (hours % 12 || 12).toString().padStart(2, "0");
  const formattedTime = `${formattedHours}:${minutes}${ampm}`;
  return { date: formattedDate, time: formattedTime };
};

Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  i18n,

  render: (h) => h(App),
}).$mount("#app");
